// extracted by mini-css-extract-plugin
export var root = "V5ny";
export var rootHeading = "kzhR";
export var rootScore = "EQL3";
export var rootScoreMsg = "RMLr";
export var rootScoreMsgShow = "BD+s";
export var rootScoreStars = "KbAY";
export var rootScoreValue = "PzvQ";
export var rootVotes = "E40r";